import { deleteLocalStorageAuth } from 'utils/local-storage';
import { clearAllAccounts, clearAllPoolTokens } from './accounts';

export const clearAllAccountsAndTokens = (): void => {
  clearAllPoolTokens();
  clearAllAccounts();
  deleteLocalStorageAuth();
};
